import { safeCredentials } from './dom';
import { handle } from './logging';

export const logout = () => {
  return fetch('/u/sign_out', safeCredentials({ method: 'DELETE' })).then(
    () => window.location.reload(),
    () => handle(new Error('User logout action failed')),
  );
};
